import { Typography } from 'antd'
import classnames from 'classnames'

export default function Span({ small = false, medium = false, className, ...props }) {
  return (
    <Typography.Text
      className={classnames(className, {
        'font-size-small': small,
        'font-medium': medium,
      })}
      {...props}
    />
  )
}
